module.exports = __webpack_public_path__ + "static/media/GD.a270f097.png";